import styled, { keyframes } from 'styled-components';
import type { JSX } from 'react';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

type Props = {
  width?: number;
  height?: number;
};

const LoadingSpinnerIconSvgContainer = styled.svg<Props>`
  animation: ${spin} 1.3s linear infinite;
  fill: ${({ theme }) => theme.color.grey200};
  height: ${({ height }) => `${height}px`};
  margin: 54px 0;
  width: ${({ width }) => `${width}px`};
`;

const LoadingSpinnerIconContainer = styled.div`
  padding: 40px 0;
  text-align: center;
`;

export const LoadingSpinnerIcon = ({ width = 22, height = 19 }: Props): JSX.Element => {
  return (
    <LoadingSpinnerIconSvgContainer
      viewBox="0 0 16 13"
      height={height}
      width={width}
    >
      <g>
        <path d="M7.97691602,10.819536 C5.53644727,10.819536 3.54984233,8.88956773 3.53589679,6.5118913 L4.0577979,6.5118913 L4.98475343,6.5118913 L2.67782375,4.27005264 L0.37512,6.5118913 L1.59281882,6.5118913 L1.82735737,6.5118913 C1.84151421,9.81363565 4.58899603,12.48628 7.97691602,12.48628 C9.93879933,12.48628 11.6845268,11.5892147 12.8109458,10.1939402 L12.30785,9.70500665 L11.5877533,9.00541117 C10.7812365,10.1026259 9.46380593,10.819536 7.97691602,10.819536 Z" />
        <path d="M14.126686,6.51900268 C14.126686,6.50766569 14.1275311,6.49715321 14.1275311,6.48622847 C14.1275311,3.17252874 11.3737104,0.48628 7.97691602,0.48628 C5.9993968,0.48628 4.24056893,1.39818642 3.11562906,2.81324916 L3.63964312,3.32279542 L4.33987805,4.0034272 C5.14428191,2.88559978 6.4741789,2.15302396 7.97691602,2.15302396 C10.4264705,2.15302396 12.419203,4.09680279 12.419203,6.48622847 C12.419203,6.49715321 12.4181465,6.50766569 12.4181465,6.51859043 L11.8768062,6.51900268 L10.9654866,6.51859043 L13.2724162,8.76042908 L15.57512,6.51859043 L14.6253445,6.51859043 L14.126686,6.51900268 Z" />
      </g>
    </LoadingSpinnerIconSvgContainer>
  );
};

type LoadingSpinnerProps = Props & {
  show?: boolean;
};

export const LoadingSpinner = ({
  show = true,
  height = 19,
  width = 22,
}: LoadingSpinnerProps): JSX.Element | null => {
  if (!show) {
    return null;
  }

  return (
    <LoadingSpinnerIconContainer>
      <LoadingSpinnerIcon
        height={height}
        width={width}
      />
    </LoadingSpinnerIconContainer>
  );
};
